@if (password) {
	<div class="psm">
		<div class="psm-bars">
			@for (i of [0, 1, 2, 3, 4]; track i) {
				<div class="psm-bar" [style.background]="i < score ? level.color : undefined"></div>
			}
		</div>
	</div>
}
